import { TransactionEntity, TransactionFilter } from '../../models'

export const SET_TRANSACTIONS = 'SET_TRANSACTIONS'
export const SET_TRANSACTIONS_LOADED = 'SET_TRANSACTIONS_LOADED'
export const SET_SELECTED_TRANSACTION = 'SET_SELECTED_TRANSACTION'
export const SET_TRANSACTION_FILTER = 'SET_TRANSACTION_FILTER'
export const SET_TOTAL_TRANSACTIONS = 'SET_TOTAL_TRANSACTIONS'
export const SET_TOTAL_AMOUNT_OF_TRANSACTIONS = 'SET_TOTAL_AMOUNT_OF_TRANSACTIONS'
export const SET_TOTAL_VOLUME_OF_TRANSACTIONS = 'SET_TOTAL_VOLUME_OF_TRANSACTIONS'

export interface TransactionState {
  transactions: TransactionEntity[]
  totalTransactions: number
  totalAmountOfTransactions: number
  totalVolumeOfTransactions: number
  isTransactionsLoaded: boolean
  selectedTransaction: TransactionEntity | null
  transactionFilter: TransactionFilter
}

interface SetTransactionsAction {
  type: typeof SET_TRANSACTIONS
  payload: TransactionEntity[]
}

interface SetTransactionsLoadedAction {
  type: typeof SET_TRANSACTIONS_LOADED
  payload: boolean
}

interface SetSelectedTransactionAction {
  type: typeof SET_SELECTED_TRANSACTION
  payload: TransactionEntity | null
}

interface SetTransactionFilterAction {
  type: typeof SET_TRANSACTION_FILTER
  payload: TransactionFilter
}

interface SetTotalTransactionsAction {
  type: typeof SET_TOTAL_TRANSACTIONS
  payload: number
}

interface SetTotalAmountOfTransactionsAction {
  type: typeof SET_TOTAL_AMOUNT_OF_TRANSACTIONS
  payload: number
}

interface SetTotalVolumeOfTransactionsAction {
  type: typeof SET_TOTAL_VOLUME_OF_TRANSACTIONS
  payload: number
}

export type TransactionAction =
  | SetTransactionsAction
  | SetTransactionsLoadedAction
  | SetSelectedTransactionAction
  | SetTransactionFilterAction
  | SetTotalTransactionsAction | SetTotalAmountOfTransactionsAction | SetTotalVolumeOfTransactionsAction
